import { render } from "./scoreBox.vue?vue&type=template&id=3fa1d745&scoped=true"
import script from "./scoreBox.vue?vue&type=script&lang=js"
export * from "./scoreBox.vue?vue&type=script&lang=js"

import "./scoreBox.vue?vue&type=style&index=0&id=3fa1d745&scoped=true&lang=css"

import exportComponent from "/Users/dgorski/tenball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa1d745"]])

export default __exports__